import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  FaUser,
  FaMapMarkerAlt,
  FaStickyNote,
  FaUsers,
  FaFileExcel,
  FaSave,
  FaRedo,
  FaTimes,
} from "react-icons/fa";

import Layout from "../layout/Layout";
import "./AddContact.css";

const API = "https://data.shreemwell.in/api/contacts";

const initialForm = {
  firstName: "",
  lastName: "",
  nickname: "",

  mobile: "",
  alternateMobile: "",
  whatsappNumber: "",
  email: "",

  currentLocation: "",
  workLocation: [],
  whichLocation: [],

  contactLevel: "",
  relationType: "",

  personalNote: "",

  upline: "",
  uplineName: "",
  uplineCode: "",

  saoName: "",
  saoCode: "",

  sgoName: "",
  sgoCode: "",

  ssgName: "",
  ssgCode: "",

  dateOfBirth: "", // <-- Add this
};

const EditContact = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);

  const [suggestions, setSuggestions] = useState([]);
  const [activeField, setActiveField] = useState("");

  const [excelFile, setExcelFile] = useState(null);

  const [formData, setFormData] = useState(initialForm);

  const [sameAsMobile, setSameAsMobile] = useState(false);

  const [citySuggestions, setCitySuggestions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);

  const [errors, setErrors] = useState({});
    // ==========================================
  // Form Validation
  // ==========================================
  const validateForm = () => {
    const newErrors = {};

    // First Name
    if (
      formData.firstName &&
      !/^[A-Za-z ]{2,50}$/.test(formData.firstName.trim())
    ) {
      newErrors.firstName =
        "First name should contain only letters (2-50 characters).";
    }

    // Last Name
    if (
      formData.lastName &&
      !/^[A-Za-z ]{2,50}$/.test(formData.lastName.trim())
    ) {
      newErrors.lastName =
        "Last name should contain only letters (2-50 characters).";
    }

    // Nickname
    if (formData.nickname && formData.nickname.length > 30) {
      newErrors.nickname =
        "Nickname should not exceed 30 characters.";
    }

    // Mobile
    if (!formData.mobile.trim()) {
      newErrors.mobile = "Mobile Number is required.";
    } else if (!/^[6-9]\d{9}$/.test(formData.mobile.trim())) {
      newErrors.mobile =
        "Enter a valid 10-digit Indian mobile number.";
    }

    // Alternate Mobile
    if (
      formData.alternateMobile &&
      !/^[6-9]\d{9}$/.test(formData.alternateMobile.trim())
    ) {
      newErrors.alternateMobile =
        "Enter a valid alternate mobile number.";
    }

    // WhatsApp
    if (
      formData.whatsappNumber &&
      !/^[6-9]\d{9}$/.test(formData.whatsappNumber.trim())
    ) {
      newErrors.whatsappNumber =
        "Enter a valid WhatsApp number.";
    }

    // Email
    if (
      formData.email &&
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
        formData.email.trim()
      )
    ) {
      newErrors.email = "Enter a valid email address.";
    }

    // Upline Code
    if (
      formData.uplineCode &&
      !/^[A-Za-z0-9]{3,20}$/.test(formData.uplineCode.trim())
    ) {
      newErrors.uplineCode =
        "Upline Code should be 3-20 characters.";
    }

    // SAO Code
    if (
      formData.saoCode &&
      !/^[A-Za-z0-9]{3,20}$/.test(formData.saoCode.trim())
    ) {
      newErrors.saoCode = "Invalid SAO Code.";
    }

    // SGO Code
    if (
      formData.sgoCode &&
      !/^[A-Za-z0-9]{3,20}$/.test(formData.sgoCode.trim())
    ) {
      newErrors.sgoCode = "Invalid SGO Code.";
    }

    // SSG Code
    if (
      formData.ssgCode &&
      !/^[A-Za-z0-9]{3,20}$/.test(formData.ssgCode.trim())
    ) {
      newErrors.ssgCode = "Invalid SSG Code.";
    }

    // Personal Note
    if (formData.personalNote.length > 500) {
      newErrors.personalNote =
        "Personal note should not exceed 500 characters.";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // ==========================================
// Update Contact
// ==========================================
const handleSubmit = async (e) => {
  e.preventDefault();

  if (!validateForm()) {
    toast.error("Please fix the validation errors.");
    return;
  }

  try {
    setLoading(true);

    const token = localStorage.getItem("token");

    const res = await axios.put(
      `${API}/${id}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (res.data.success) {
      toast.success("Contact updated successfully!");

      setTimeout(() => {
        navigate("/ContactMangement");
      }, 1000);
    } else {
      toast.error(res.data.message || "Failed to update contact.");
    }
  } catch (error) {
    console.error(error);

    toast.error(
      error.response?.data?.message || "Something went wrong."
    );
  } finally {
    setLoading(false);
  }
};

  // ==========================================
  // Load Existing Contact
  // ==========================================
  const fetchContact = async () => {
    try {
      setLoading(true);

      const token = localStorage.getItem("token");

const res = await axios.get(`${API}/${id}`, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

      if (res.data.success) {
        const contact = res.data.data;

      setFormData({
  ...initialForm,
  ...contact,

  workLocation: Array.isArray(contact.workLocation)
    ? contact.workLocation
    : [],

  whichLocation: Array.isArray(contact.whichLocation)
    ? contact.whichLocation
    : [],

  dateOfBirth: contact.dateOfBirth
    ? contact.dateOfBirth.substring(0, 10)
    : "",
});

        if (
          contact.mobile &&
          contact.mobile === contact.whatsappNumber
        ) {
          setSameAsMobile(true);
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Unable to load contact.");
    } finally {
      setLoading(false);
    }
  };

  // ==========================================
  // Load Data On Page Open
  // ==========================================
  useEffect(() => {
    if (id) {
      fetchContact();
    }
  }, [id]);
    // ==========================================
  // Search Location
  // ==========================================
  const searchLocation = async (query, field) => {
    if (!query || query.length < 2) {
      setSuggestions([]);
      return;
    }

    try {
      const res = await fetch(
        `https://photon.komoot.io/api/?q=${encodeURIComponent(
          query
        )}&limit=10`
      );

      const data = await res.json();

      const uniqueCities = [
        ...new Set(
          data.features
            .filter(
              (item) => item.properties.country === "India"
            )
            .map(
              (item) =>
                item.properties.city ||
                item.properties.name ||
                item.properties.state
            )
            .filter(Boolean)
        ),
      ];

      setSuggestions(uniqueCities);
      setActiveField(field);
    } catch (error) {
      console.error(error);
    }
  };

  // ==========================================
  // Select Location
  // ==========================================
  const selectLocation = (city) => {
    setFormData((prev) => {
      if (activeField === "workLocation") {
        if (prev.workLocation.includes(city)) return prev;

        return {
          ...prev,
          workLocation: [...prev.workLocation, city],
        };
      }

      if (activeField === "whichLocation") {
        if (prev.whichLocation.includes(city)) return prev;

        return {
          ...prev,
          whichLocation: [...prev.whichLocation, city],
        };
      }

      return {
        ...prev,
        [activeField]: city,
      };
    });

    setSuggestions([]);
    setActiveField("");
  };

  // ==========================================
  // Handle Input Change
  // ==========================================
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      const updated = {
        ...prev,
        [name]: value,
      };

      // Keep WhatsApp synced with Mobile
      if (name === "mobile" && sameAsMobile) {
        updated.whatsappNumber = value;
      }

      return updated;
    });
  };

  // ==========================================
  // Same As Mobile Checkbox
  // ==========================================
  const handleSameAsMobile = (e) => {
    const checked = e.target.checked;

    setSameAsMobile(checked);

    setFormData((prev) => ({
      ...prev,
      whatsappNumber: checked ? prev.mobile : "",
    }));
  };

  // ==========================================
  // Reset Form
  // ==========================================
  const handleReset = () => {
    fetchContact();
  };
  return (
  <Layout>
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      pauseOnHover
      draggable
      theme="colored"
    />

    <div className="contact-page">

      {/* ========================= */}
      {/* PAGE HEADER */}
      {/* ========================= */}

      <div className="page-header">
        <div>
          <h2>Edit Contact</h2>
          <p>
            Update the contact information and save your changes.
          </p>
        </div>
      </div>

      {/* ========================= */}
      {/* FORM START */}
      {/* ========================= */}

      <form onSubmit={handleSubmit}>

        {/* ========================================= */}
        {/* BASIC INFORMATION CARD */}
        {/* ========================================= */}

        <div className="card">

          <div className="card-title">
            <FaUser />
            <span>Basic Information</span>
          </div>

          <div className="form-grid">
                        {/* First Name */}
            <div className="form-group">
              <label>First Name</label>
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                placeholder="Enter first name"
              />
              {errors.firstName && (
                <small className="error-text">{errors.firstName}</small>
              )}
            </div>

            {/* Last Name */}
            <div className="form-group">
              <label>Last Name</label>
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                placeholder="Enter last name"
              />
              {errors.lastName && (
                <small className="error-text">{errors.lastName}</small>
              )}
            </div>

            {/* Nickname */}
            <div className="form-group">
              <label>Nickname</label>
              <input
                type="text"
                name="nickname"
                value={formData.nickname}
                onChange={handleChange}
                placeholder="Enter nickname"
              />
              {errors.nickname && (
                <small className="error-text">{errors.nickname}</small>
              )}
            </div>


            <div className="form-group">
  <label>Date of Birth</label>

  <input
    type="date"
    name="dateOfBirth"
    value={formData.dateOfBirth}
    onChange={handleChange}
  />
</div>

            {/* Mobile */}
            <div className="form-group">
              <label>Mobile Number *</label>
              <input
                type="text"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                placeholder="9876543210"
                required
              />
              {errors.mobile && (
                <small className="error-text">{errors.mobile}</small>
              )}
            </div>

            {/* Alternate Mobile */}
            <div className="form-group">
              <label>Alternate Mobile</label>
              <input
                type="text"
                name="alternateMobile"
                value={formData.alternateMobile}
                onChange={handleChange}
                placeholder="Alternate number"
              />
              {errors.alternateMobile && (
                <small className="error-text">
                  {errors.alternateMobile}
                </small>
              )}
            </div>

            {/* WhatsApp */}
            <div className="form-group">
              <label>WhatsApp Number</label>

              <input
                type="text"
                name="whatsappNumber"
                value={formData.whatsappNumber}
                onChange={handleChange}
                placeholder="WhatsApp Number"
                disabled={sameAsMobile}
              />

              <div className="checkbox-inline">
                <input
                  type="checkbox"
                  id="sameAsMobile"
                  checked={sameAsMobile}
                  onChange={handleSameAsMobile}
                />

                <label
                  htmlFor="sameAsMobile"
                  className="checkbox-label"
                >
                  Same as Mobile Number
                </label>
              </div>

              {errors.whatsappNumber && (
                <small className="error-text">
                  {errors.whatsappNumber}
                </small>
              )}
            </div>

            {/* Email */}
            <div className="form-group">
              <label>Email Address</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="example@gmail.com"
              />
              {errors.email && (
                <small className="error-text">{errors.email}</small>
              )}
            </div>

            {/* Relationship Level */}
            <div className="form-group">
              <label>Relationship Level</label>

              <select
                name="contactLevel"
                value={formData.contactLevel}
                onChange={handleChange}
              >
                <option value="">Relationship Level</option>
                <option value="Relative">Relative</option>
                <option value="Friend">Friend</option>
                <option value="Colleague">Colleague</option>
                <option value="Neighbour">Neighbour</option>
                <option value="Society friend">
                  Society friend
                </option>
                <option value="From group">
                  From group
                </option>
              </select>
            </div>

            {/* Relation Type */}
            <div className="form-group">
              <label>Relation Type</label>

              <select
                name="relationType"
                value={formData.relationType}
                onChange={handleChange}
              >
                <option value="">Select Relation Type</option>
                <option value="Between persons">
                  Between persons
                </option>
                <option value="Only user">
                  Only user
                </option>
                <option value="Only partner">
                  Only partner
                </option>
              </select>
            </div>

          </div>
        </div>

        {/* ========================= */}
        {/* LOCATION DETAILS CARD */}
        {/* ========================= */}
                <div className="card">

          <div className="card-title">
            <FaMapMarkerAlt />
            <span>Location Details</span>
          </div>

          <div className="form-grid">

            {/* Current Location */}
            <div className="form-group">
              <label>Current Location</label>

              <div className="location-box">
                <input
                  type="text"
                  className="single-location-input"
                  value={formData.currentLocation}
                  placeholder="Search current city..."
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      currentLocation: e.target.value,
                    });

                    searchLocation(
                      e.target.value,
                      "currentLocation"
                    );
                  }}
                />

                {activeField === "currentLocation" &&
                  suggestions.length > 0 && (
                    <ul className="location-list">
                      {suggestions.map((city) => (
                        <li
                          key={city}
                          onClick={() => selectLocation(city)}
                        >
                          <FaMapMarkerAlt className="location-icon" />
                          {city}
                        </li>
                      ))}
                    </ul>
                  )}
              </div>
            </div>

            {/* Work Location */}
            <div className="form-group">
              <label>Work Location</label>

              <div className="location-box">

                <input
                  type="text"
                  className="single-location-input"
                  placeholder="Search work city..."
                  onChange={(e) =>
                    searchLocation(
                      e.target.value,
                      "workLocation"
                    )
                  }
                />

                <div className="selected-wrapper">
                  <div className="selected-location-scroll">
                    {formData.workLocation.map((city) => (
                      <div
                        className="city-chip"
                        key={city}
                      >
                        <span>{city}</span>

                        <button
                          type="button"
                          onClick={() =>
                            setFormData((prev) => ({
                              ...prev,
                              workLocation:
                                prev.workLocation.filter(
                                  (x) => x !== city
                                ),
                            }))
                          }
                        >
                          ×
                        </button>
                      </div>
                    ))}
                  </div>
                </div>

                {activeField === "workLocation" &&
                  suggestions.length > 0 && (
                    <ul className="location-list">
                      {suggestions.map((city) => (
                        <li
                          key={city}
                          onClick={() => selectLocation(city)}
                        >
                          <FaMapMarkerAlt className="location-icon" />
                          {city}
                        </li>
                      ))}
                    </ul>
                  )}
              </div>
            </div>

            {/* Preferred Location */}
            <div className="form-group">
              <label>Preferred Location</label>

              <div className="location-box">

                <input
                  type="text"
                  className="single-location-input"
                  placeholder="Search preferred city..."
                  onChange={(e) =>
                    searchLocation(
                      e.target.value,
                      "whichLocation"
                    )
                  }
                />

                <div className="selected-wrapper">
                  <div className="selected-location-scroll">
                    {formData.whichLocation.map((city) => (
                      <div
                        className="city-chip"
                        key={city}
                      >
                        <span>{city}</span>

                        <button
                          type="button"
                          onClick={() =>
                            setFormData((prev) => ({
                              ...prev,
                              whichLocation:
                                prev.whichLocation.filter(
                                  (x) => x !== city
                                ),
                            }))
                          }
                        >
                          ×
                        </button>
                      </div>
                    ))}
                  </div>
                </div>

                {activeField === "whichLocation" &&
                  suggestions.length > 0 && (
                    <ul className="location-list">
                      {suggestions.map((city) => (
                        <li
                          key={city}
                          onClick={() => selectLocation(city)}
                        >
                          <FaMapMarkerAlt className="location-icon" />
                          {city}
                        </li>
                      ))}
                    </ul>
                  )}
              </div>
            </div>

          </div>
        </div>

        {/* ========================= */}
        {/* PERSONAL NOTE CARD */}
        {/* ========================= */}
                {/* ========================= */}
        {/* PERSONAL NOTE */}
        {/* ========================= */}

        <div className="card">

          <div className="card-title">
            <FaStickyNote />
            <span>Personal Note</span>
          </div>

          <div className="form-group">
            <label className="note-label">Note</label>

            <textarea
              rows={4}
              name="personalNote"
              value={formData.personalNote}
              onChange={handleChange}
              placeholder="Write personal notes..."
              className="textarea"
            />

            {errors.personalNote && (
              <small className="error-text">
                {errors.personalNote}
              </small>
            )}
          </div>

        </div>

     <div className="card">

  <div className="card-title">
    <FaUsers />
    <span>Team Details</span>
  </div>

  <table className="team-details-table">

    <thead>
      <tr>
        <th>Relationship</th>
        <th>Name</th>
        <th>Code</th>
      </tr>
    </thead>

    <tbody>

      {/* Upline */}
      <tr>

        <td className="relationship-cell">
          <span>Upline</span>

          <select
            name="upline"
            value={formData.upline}
            onChange={handleChange}
          >
            <option value="">Select</option>
            <option value="SAO">SAO</option>
            <option value="SGO">SGO</option>
            <option value="SSG">SSG</option>
            <option value="SEL">SEL</option>
          </select>
        </td>

        <td>
          <input
            type="text"
            name="uplineName"
            value={formData.uplineName}
            onChange={handleChange}
            placeholder="Enter Upline Name"
          />
        </td>

        <td>
          <input
            type="text"
            name="uplineCode"
            value={formData.uplineCode}
            onChange={handleChange}
            placeholder="Enter Upline Code"
          />
        </td>

      </tr>

      {/* Downline SAO */}
      <tr>

        <td className="relationship-label">
          Downline SAO
        </td>

        <td>
          <input
            type="text"
            name="saoName"
            value={formData.saoName}
            onChange={handleChange}
            placeholder="Enter SAO Name"
          />
        </td>

        <td>
          <input
            type="text"
            name="saoCode"
            value={formData.saoCode}
            onChange={handleChange}
            placeholder="Enter SAO Code"
          />
        </td>

      </tr>

      {/* Downline SGO */}
      <tr>

        <td className="relationship-label">
          Downline SGO
        </td>

        <td>
          <input
            type="text"
            name="sgoName"
            value={formData.sgoName}
            onChange={handleChange}
            placeholder="Enter SGO Name"
          />
        </td>

        <td>
          <input
            type="text"
            name="sgoCode"
            value={formData.sgoCode}
            onChange={handleChange}
            placeholder="Enter SGO Code"
          />
        </td>

      </tr>

    </tbody>

  </table>

</div>

        {/* ========================= */}
        {/* ACTION BUTTONS */}
        {/* ========================= */}

        <div className="button-section">

          <button
            type="button"
            className="btn btn-cancel"
            onClick={() => navigate("/ContactMangement")}
          >
            <FaTimes />
            <span className="btn-con">Cancel</span>
          </button>

          <button
            type="button"
            className="btn btn-reset"
            onClick={handleReset}
          >
            <FaRedo />
            <span className="btn-con">Reset</span>
          </button>

          <button
            type="submit"
            className="btn btn-save"
            disabled={loading}
          >
            <FaSave />
            <span className="btn-con">
              {loading ? "Updating..." : "Update Contact"}
            </span>
          </button>

        </div>

      </form>

    </div>

  </Layout>
);

};

export default EditContact;